export default "__VITE_PUBLIC_ASSET__14f4a082__"